import { render, staticRenderFns } from "./AppInfoList.vue?vue&type=template&id=8aca532e&scoped=true&"
import script from "./AppInfoList.vue?vue&type=script&lang=js&"
export * from "./AppInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aca532e",
  null
  
)

export default component.exports